// extracted by mini-css-extract-plugin
export default {"faq_section":"faq_faq_section__BIs3d","faq":"faq_faq__anB6S","collapse":"faq_collapse__vzdXx"};